import { AccountRepository, UnauthenticatedAccountRepository } from ".";
import { IAccountRegistry, IAccountRepository, IUnauthenticatedAccountRepository } from "../../../domain/account";

export class AccountRegistry implements IAccountRegistry {
  constructor(private _getToken: () => string) {
  }

  getAccountRepository(): IAccountRepository {
    return new AccountRepository(this._getToken);
  }

  getUnauthenticatedAccountRepository(): IUnauthenticatedAccountRepository {
    return new UnauthenticatedAccountRepository();
  }
}
